import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d78e6de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, " City Edit")
  ])
], -1))
const _hoisted_4 = { class: "col-5 mt-4 text-start" }
const _hoisted_5 = { class: "form-floating" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "City Name", -1))
const _hoisted_7 = { class: "form-floating" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "City Name Urdu", -1))
const _hoisted_9 = { class: "form-floating" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "City Push Topic", -1))
const _hoisted_11 = { class: "form-floating" }
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Country", -1))
const _hoisted_14 = { class: "form-check" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Is Show ", -1))
const _hoisted_16 = { class: "form-check" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " is second order cron ", -1))
const _hoisted_18 = { class: "form-check" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " is third order cron ", -1))
const _hoisted_20 = { class: "form-floating" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Rider Booking Price start Fixed", -1))
const _hoisted_22 = { class: "form-floating" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Rider Booking Price start Flexible", -1))
const _hoisted_24 = { class: "form-floating" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Rider Booking Note Flexible", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary",
  type: "submit"
}, "Submit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.name) = $event)),
              class: "form-control",
              placeholder: "City Name",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.name]
            ]),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.name_urdu) = $event)),
              class: "form-control",
              placeholder: "City Name Urdu",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.name_urdu]
            ]),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.city_topic) = $event)),
              class: "form-control",
              placeholder: "City Push Topic",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.city_topic]
            ]),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.country_id) = $event)),
              class: "form-control",
              required: ""
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.countries, (country) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: country.id,
                  value: country.id
                }, _toDisplayString(country.name), 9, _hoisted_12))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.data.country_id]
            ]),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.is_show) = $event)),
              class: "form-check-input",
              type: "checkbox",
              id: "flexCheckDefault"
            }, null, 512), [
              [_vModelCheckbox, $setup.data.is_show]
            ]),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.is_second_order_cron) = $event)),
              class: "form-check-input",
              type: "checkbox",
              id: "flexCheckDefault"
            }, null, 512), [
              [_vModelCheckbox, $setup.data.is_second_order_cron]
            ]),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.is_third_order_cron) = $event)),
              class: "form-check-input",
              type: "checkbox",
              id: "flexCheckDefault"
            }, null, 512), [
              [_vModelCheckbox, $setup.data.is_third_order_cron]
            ]),
            _hoisted_19
          ]),
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.data.booking_price_fixed) = $event)),
              type: "number",
              step: "0.1",
              class: "form-control",
              placeholder: "second package price",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.booking_price_fixed]
            ]),
            _hoisted_21
          ]),
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.data.booking_price_flexible) = $event)),
              type: "number",
              step: "0.1",
              class: "form-control",
              placeholder: "second package price",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.booking_price_flexible]
            ]),
            _hoisted_23
          ]),
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.data.booking_flexible_note) = $event)),
              type: "text",
              class: "form-control",
              placeholder: "second package price",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.booking_flexible_note]
            ]),
            _hoisted_25
          ]),
          _hoisted_26
        ], 32)
      ])
    ])
  ]))
}